import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from '@/scopes/checkout/components/PersonalDetailsForm/Form.module.css'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { availablePhoneCountriesSelector } from '@/scopes/checkout/components/PersonalDetailsForm/selectors'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { useParticipantsFormStepStore } from '@/scopes/checkout/infrastructure/store/useParticipantsFormStepStore'
import { PhoneInput } from '@/scopes/common/components/FormElements/PhoneInput'
import { getPhoneDigitsFromPattern, getPhoneExampleFromDigits } from '@/scopes/common/components/FormElements/utils/phonePatternUtils'

export function EmergencyPhoneNumberInput({
  name,
  required = false,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  const availablePhoneCountries = useParticipantsFormStepStore(availablePhoneCountriesSelector)
  useTrackFieldValidation(name)

  return (
    <PhoneInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_emergency_phone' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_emergency_phone' })}
      patternErrorMessage={
        (selectedCountry) => {
          const phoneDigits = getPhoneDigitsFromPattern(selectedCountry?.pattern)

          return intl.formatMessage(
            { id: 'checkout_steps_participants_form_field_pattern_error_message_emergency_phone' },
            { phoneDigits, phoneExample: getPhoneExampleFromDigits(phoneDigits) },
          )
        }
      }
      countries={availablePhoneCountries}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldM)}
    />
  )
}
